import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../assets/global/url";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import "../../assets/css/style.css";
import { customStyles } from "../../assets/table-style";
// import { customStyles } from "../styles/table-style";
import { Plus, FadersHorizontal, MagnifyingGlass } from "@phosphor-icons/react";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import { format } from "date-fns";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";
import FilterStore from "../../hooks/customHook/FilterStore";
const Expenses1 = ({ authrztn }) => {
  const isFirstRender = useRef(true);
  const pageRestored = useRef(false);
  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModalExpense, setShowModalExpense] = useState(false);
  const [showUpdatedModalExpenses, setShowModalUpdateExpenses] =
    useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [expensesTypeOne, setExpensesTypeOne] = useState("");
  const [description, setDescription] = useState("");
  const [expensesId, setExpensesId] = useState("");
  const [expensesOneData, setExpensesOneData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  //PARA SA FILTER RETENTION
  //START
  const [searchText, setSearchText] = useState(() => FilterStore.E1getSearch());
  ///saving the value of search to transfer on custom hook
  useEffect(() => {
    FilterStore.E1saveSearch(searchText);
  }, [searchText]);
  const [filterColumn, setFilterColumn] = useState(
    () => FilterStore.E1getFilterColumn() || "all",
  );
  ///saving the value of filterColumn to retain it across visits
  useEffect(() => {
    FilterStore.E1saveFilterColumn(filterColumn);
  }, [filterColumn]);
  const [filterStatus, setFilterStatus] = useState(() =>
    FilterStore.E1getStatus(),
  );
  ///saving the value of search to transfer on custom hook
  useEffect(() => {
    FilterStore.E1saveStatus(filterStatus);
  }, [filterStatus]);
  //END
  const [isArchive, setIsArchive] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [fetchTrigger, setFetchTrigger] = useState(false);
  const handleCloseExpenseModal = () => {
    setShowModalExpense(false);
    setIsSubmitting(false);
  };
  const handleShowExpenseModal = () => setShowModalExpense(true);

  const userLoggedID = useDecodeToken();
  const [incomeStatementCheckBox, setIncomeStatementCheckbox] = useState(true);

  const handleClose = () => {
    setShowModalUpdateExpenses(false);
  };

  const handleFilterStatus = (e) => {
    setFilterStatus(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please fill in all required fields.",
      });
    } else {
      setIsSubmitting(true);
      swal({
        title: "Create this Expense Type?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          axios
            .post(BASE_URL + "/expenseone/create", {
              expensesTypeOne: expensesTypeOne.trim(),
              description: description.trim(),
              incomeStatementCheckBox,
              userLoggedID,
            })
            .then((response) => {
              if (response.status === 200) {
                swal({
                  title: "Expense Type Added Successfully!",
                  text: "The new expense type has been added successfully.",
                  icon: "success",
                  button: "OK",
                }).then(() => {
                  setShowModalExpense(false);
                  pagination.setCurrentPage(1);
                  FilterStore.E1savePage(1);
                  reloadExpensesOne();
                  setExpensesTypeOne("");
                  setDescription("");
                  setValidated(false);
                });
              } else if (response.status === 201) {
                swal({
                  title: "Expense Type Already Exists",
                  text: "Please input a new expenses.",
                  icon: "error",
                });
              }
            })
            .finally(() => {
              setIsSubmitting(false);
            });
        } else {
          setIsSubmitting(false);
        }
      });
    }
    setValidated(true);
  };

  const handleFormUpdate = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else {
      swal({
        title: "Update this Expenses?",
        text: "Are you sure you want to update",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          axios
            .put(`${BASE_URL}/expenseone/updateExpenses1`, {
              expensesId,
              expensesTypeOne: expensesTypeOne.trim(),
              description: description.trim(),
              incomeStatementCheckBox,
              userLoggedID,
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Expense Type updated successfully",
                  text: "",
                  icon: "success",
                  successMode: true,
                }).then(() => {
                  handleCloseUpdateExpensesModal();
                  reloadExpensesOne();
                });
              } else if (res.status === 201) {
                swal({
                  title: "Expense Type already exist",
                  text: "Please input another expenses name",
                  icon: "error",
                  dangerMode: true,
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact your support immediately",
                  icon: "error",
                  dangerMode: true,
                }).then(() => {
                  handleCloseUpdateExpensesModal();
                  reloadExpensesOne();
                });
              }
            });
        }
      });
    }
    setValidated(true);
  };

  const handleUnarchive = async (rowExpensesId) => {
    swal({
      title: "Confirm Unarchive",
      text: "Are you sure you want to unarchive this expenses?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.put(
            `${BASE_URL}/expenseone/unarchiveExpense`,
            {
              expensesId: rowExpensesId,
              userLoggedID,
            },
          );

          if (response.status === 200) {
            swal({
              title: "Expense Type Unarchived Successfully!",
              text: "The expense type has been successfully unarchived.",
              icon: "success",
              button: "OK",
            }).then(() => {
              handleCloseUpdateExpensesModal();
              reloadExpensesOne();
            });
          }
        } catch (err) {
          console.log(err);
        }
      }
    });
  };

  const deleteExpensesRow = async (rowExpensesId) => {
    swal({
      title: "Confirm Archive",
      text: "Are you sure you want to archive this expenses?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(
            BASE_URL + `/expenseone/deleteExpenseOne/`,
            { data: { expensesId: rowExpensesId, userLoggedID } },
          );
          if (response.status === 200) {
            swal({
              title: "Expense Type Archived Successfully!",
              text: "The expense type has been successfully archived.",
              icon: "success",
              button: "OK",
            }).then(() => {
              handleCloseUpdateExpensesModal();
              reloadExpensesOne();
            });
          } else if (response.status === 202) {
            swal({
              icon: "error",
              title: "Deletion Prohibited",
              text: "You cannot delete an expense type one that is in use.",
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact our support team for assistance.",
            });
          }
        } catch (err) {
          console.log(err);
        }
      }
    });
  };

  const pagination = useServerPagination(
    `${BASE_URL}/expenseone/getExpensesOneForFilter`,
    FilterStore.E1getPerPage(),
  );

  // Matches the backend default order so the Date Created header starts highlighted
  const sort = useServerSort(pagination, {
    sortBy: "createdAt",
    sortDirection: "DESC",
  });

  ///PARA ITO SA FILTER RETENTION NG PAGE (same pattern as Currency)
  //START
  // Save current page to FilterStore whenever it changes.
  // Gate is closed until after mount restore so the 1000ms debounced
  // reloadExpensesOne → updateParams → reset-to-1 doesn't overwrite the saved page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.E1savePage(pagination.currentPage);
    }
  }, [pagination.currentPage]);

  // Save current perPage to FilterStore whenever it changes
  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.E1savePerPage(pagination.itemsPerPage);
    }
  }, [pagination.itemsPerPage]);

  // Restore the last viewed page on mount. Deferred 1100ms so it runs after
  // the debounced reloadExpensesOne → updateParams → reset-to-1 has settled,
  // then opens the save gate for user navigation.
  useEffect(() => {
    const savedPage = FilterStore.E1getPage();
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 1100);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 0);
    }
  }, []);
  //END

  const reloadExpensesOne = async () => {
    pagination.updateParams({
      filterStatus,
      filterColumn,
      searchText,
    });
    setFetchTrigger(true);
    // try {
    //   const res = await axios.get(
    //     `${BASE_URL}/expenseone/getExpensesOneForFilter`,
    //     {
    //       params: {
    //         filterStatus,
    //         filterColumn,
    //         searchText,
    //       },
    //     }
    //   );
    //   setExpensesOneData(res.data);
    //   setIsLoading(false);
    // } catch (error) {
    //   console.error(error);
    // }
  };

  const handleCancelEdit = () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      text: "Your changes will not be saved",
      dangerMode: true,
      buttons: ["Cancel", "OK"],
    }).then((confirm) => {
      if (confirm) {
        handleCloseUpdateExpensesModal();
      }
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      reloadExpensesOne();
    }, 1000);
    return () => clearTimeout(timer);
  }, [filterStatus, filterColumn, searchText]);

  // Reset to page 1 whenever search/column/status filters change so
  // results stay consistent. Skips the first run (mount) so it doesn't
  // stomp the page that was just restored above.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    pagination.setCurrentPage(1);
    FilterStore.E1savePage(1);
  }, [searchText, filterColumn, filterStatus]);

  useEffect(() => {
    if (pagination.data) {
      setExpensesOneData(pagination.data);
      if (pagination.data.length > 0) {
        setIsLoading(false);
      }

      if (pagination.data.length === 0 && fetchTrigger) {
        setIsLoading(false);
      }
    }
  }, [pagination.data]);

  const handleCloseUpdateExpensesModal = () => {
    setShowModalExpense(false);
    setShowModalUpdateExpenses(false);
    setValidated(false);
    setIsEditing(false);
    setExpensesTypeOne("");
    setDescription("");
    setExpensesId("");
  };

  const handleUpdateModal = async (data) => {
    setShowModalUpdateExpenses(true);
    setExpensesId(data.expenses_one_id);
    setExpensesTypeOne(data.expenses_type_one);
    setDescription(data.description);
    setIsArchive(data.isArchive);
    setIncomeStatementCheckbox(data.isForIncomeStatement);
  };

  function formatDate(datetime) {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(datetime).toLocaleString("en-US", options);
  }

  const columns = [
    {
      name: "Expense Type",
      selector: (row) => row.expenses_type_one,
      sortField: "expenses_type_one",
    },
    {
      name: "Description",
      selector: (row) => row.description || "--",
      sortField: "description",
    },
    {
      name: "Date Created",
      selector: (row) => format(row.createdAt, "MMM/dd/yyyy, hh:mm a"),
      sortField: "createdAt",
    },
    {
      name: "Status",
      selector: (row) => row.isArchive,
      sortField: "isArchive",
      cell: (row) => {
        let fontColor;
        row.isArchive === false
          ? (fontColor = "#3B9F3F")
          : (fontColor = "#767676");
        return (
          <div
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              color: fontColor,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            {" "}
            {row.isArchive === false ? "Active" : "Archive"}
          </div>
        );
      },
    },
  ];

  if (authrztn.includes("ExpensesType1-Delete")) {
    columns.push({
      name: "Action",
      selector: (row) => (
        <>
          {row.isArchive ? (
            <>
              <Button
                variant="danger"
                onClick={() => handleUnarchive(row.expenses_one_id)}
              >
                Unarchive
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="danger"
                onClick={() => deleteExpensesRow(row.expenses_one_id)}
              >
                Archive
              </Button>
            </>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredExpsensesData = expensesOneData.filter(
    (item) =>
      item.expenses_type_one
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      formatDate(item.createdAt)
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
  );

  return (
    <>
      <div className="h-100 w-100 border bg-white custom-container">
        {isLoading ? (
          <div className="loading-container">
            <ThreeDot
              variant="brick-stack"
              color="#6290FE"
              size="large"
              text="Loading Data..."
              textColor=""
            />
          </div>
        ) : authrztn.includes("ExpensesType1-View") ? (
          <>
            <div className="expenses-content">
              <div className="row mb-3">
                <div className="col-6 title-custom">
                  <span className="fs-3">EXPENSE TYPE</span>
                </div>
                <div className="col-6">
                  {authrztn.includes("ExpensesType1-Add") && (
                    <button
                      className="float-end btn btn-primary d-flex align-items-center title-button"
                      onClick={handleShowExpenseModal}
                    >
                      {/* <Plus size={32} color="#f2f2f2" />  */}
                      <i className="bx bx-plus fs-5"></i>
                      Create
                    </button>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Filter</Form.Label>
                    <Form.Select
                      value={filterStatus}
                      onChange={handleFilterStatus}
                    >
                      <option value="All">All</option>
                      <option value="Archive">Archive</option>
                      <option value="Active" selected>
                        Active
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>

              <div className="row mb-3">
                {/* <div className="col-12">
                  <div class="input-group mb-3 border border-light border-radius-2">
                    <span
                      className="input-group-text bg-body"
                      id="basic-addon2"
                    >
                      <MagnifyingGlass size={20} color="#969696" />
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={`  Search`}
                      onChange={handleSearchChange}
                    />
                    <span
                      className="input-group-text bg-body"
                      id="basic-addon2"
                    >
                      <FadersHorizontal size={32} />
                    </span>
                  </div>
                </div> */}
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-sliders"></i>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button
                        className={`dropdown-item ${
                          filterColumn === "all" ? "active" : ""
                        }`}
                        onClick={() => setFilterColumn("all")}
                      >
                        All
                      </button>
                    </li>
                    <li>
                      <button
                        className={`dropdown-item ${
                          filterColumn === "expenses_type_one" ? "active" : ""
                        }`}
                        onClick={() => setFilterColumn("expenses_type_one")}
                      >
                        Expense Type
                      </button>
                    </li>
                    <li>
                      <button
                        className={`dropdown-item ${
                          filterColumn === "description" ? "active" : ""
                        }`}
                        onClick={() => setFilterColumn("description")}
                      >
                        Description
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <DataTable
                columns={sort.sortColumns(columns)}
                data={expensesOneData}
                customStyles={customStyles}
                onRowClicked={handleUpdateModal}
                className="dataTable"
                {...sort.sortProps}
              />

              <PaginationControls {...pagination} />
            </div>
          </>
        ) : (
          <div className="no-access">
            <img src={NoAccess} alt="NoAccess" className="no-access-img" />
            <h3>You don't have access to this function.</h3>
          </div>
        )}
      </div>

      <Modal show={showModalExpense} onHide={handleCloseExpenseModal} size="lg">
        <Form noValidate validated={validated} onSubmit={handleFormSubmit}>
          <Modal.Header closeButton>
            <h2>Create Expenses</h2>
          </Modal.Header>
          <Modal.Body>
            {/* Hidden income statement checkbox */}
            <div className="row mb-2 d-none">
              <div className="col-sm">
                <Form.Group className="d-flex">
                  <div className="me-3 mt-1">
                    <input
                      type="checkbox"
                      checked={incomeStatementCheckBox}
                      onChange={(e) => {
                        setIncomeStatementCheckbox(e.target.checked);
                      }}
                      name="income-statement-checkbox"
                      id="income-statement-checkbox"
                      className="form-check-input border border-secondary"
                    />
                  </div>
                  <Form.Label
                    className="fs-5 text-uppercase"
                    htmlFor="income-statement-checkbox"
                  >
                    Income statement
                    {/* Tooltip  */}
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip className="ms-1">
                          If checked, this will be reflected in the income
                          statement (Total Operating Expenses)
                        </Tooltip>
                      }
                    >
                      {({ ref, ...triggerHandler }) => (
                        <i
                          className="fa-solid fa-circle-info d-inline-flex align-items-center text-primary fs-6 ms-2 mb-1"
                          style={{ cursor: "pointer" }}
                          ref={ref}
                          {...triggerHandler}
                        ></i>
                      )}
                    </OverlayTrigger>
                  </Form.Label>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label className="fs-5">
                    EXPENSES TYPE NAME <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    onChange={(e) => setExpensesTypeOne(e.target.value)}
                    value={expensesTypeOne}
                    className="p-3"
                    placeholder="Expenses Type"
                  />
                </Form.Group>
              </div>
              <div className="col-6"></div>
            </div>

            <div className="row mt-3">
              <div className="">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label className="fs-5">DESCRIPTION</Form.Label>
                  <Form.Control
                    onChange={(e) => setDescription(e.target.value)}
                    as="textarea"
                    rows={3}
                    style={{
                      fontSize: "16px",
                      height: "200px",
                      maxHeight: "200px",
                      resize: "none",
                      overflowY: "auto",
                    }}
                    value={description}
                    placeholder="Enter Remarks"
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-secondary"
              variant="secondary"
              onClick={handleCloseExpenseModal}
            >
              Close
            </button>
            <Button type="submit" variant="primary" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showUpdatedModalExpenses}
        onHide={handleCloseUpdateExpensesModal}
        size="lg"
      >
        <Form noValidate validated={validated} onSubmit={handleFormUpdate}>
          <Modal.Header closeButton>
            <h2>Update Expenses</h2>
          </Modal.Header>
          <Modal.Body>
            {/* Hidden income statement checkbox */}
            <div className="row mb-2 d-none">
              <div className="col-sm">
                <Form.Group className="d-flex">
                  <div className="me-3 mt-1">
                    <input
                      type="checkbox"
                      checked={incomeStatementCheckBox}
                      disabled={isArchive || !isEditing}
                      onChange={(e) => {
                        setIncomeStatementCheckbox(e.target.checked);
                      }}
                      name="income-statement-checkbox"
                      id="income-statement-checkbox"
                      className="form-check-input border border-secondary "
                    />
                  </div>
                  <Form.Label
                    className="fs-5 text-uppercase"
                    htmlFor="income-statement-checkbox"
                  >
                    Income statement
                    {/* Tooltip  */}
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip className="ms-1">
                          If checked, this will be reflected in the income
                          statement (Total Operating Expenses)
                        </Tooltip>
                      }
                    >
                      {({ ref, ...triggerHandler }) => (
                        <i
                          className="fa-solid fa-circle-info d-inline-flex align-items-center text-primary fs-6 ms-2 mb-1"
                          style={{ cursor: "pointer" }}
                          ref={ref}
                          {...triggerHandler}
                        ></i>
                      )}
                    </OverlayTrigger>
                  </Form.Label>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label className="fs-5">EXPENSES TYPE NAME</Form.Label>
                  <Form.Control
                    className="p-3"
                    required
                    type="text"
                    disabled={isArchive || !isEditing}
                    readOnly={
                      expensesId === "11111111-1111-1111-1111-111111111111"
                    }
                    onChange={(e) => setExpensesTypeOne(e.target.value)}
                    value={expensesTypeOne}
                  />
                </Form.Group>
              </div>
              <div className="col-6"></div>
            </div>

            <div className="row mt-3">
              <div className="">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Label className="fs-5">DESCRIPTION</Form.Label>
                  <Form.Control
                    onChange={(e) => setDescription(e.target.value)}
                    as="textarea"
                    rows={3}
                    style={{
                      fontSize: "16px",
                      height: "200px",
                      maxHeight: "200px",
                      resize: "none",
                      overflowY: "auto",
                    }}
                    maxLength={50}
                    disabled={isArchive || !isEditing}
                    readOnly={
                      expensesId === "11111111-1111-1111-1111-111111111111"
                    }
                    value={description}
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {!isEditing && (
              <button
                type="button"
                variant="secondary"
                onClick={handleClose}
                className="btn btn-outline-secondary"
              >
                Close
              </button>
            )}
            <>
              {authrztn.includes("ExpensesType1-Edit") && (
                <>
                  {isArchive ? null : !isEditing ? (
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsEditing(true);
                      }}
                    >
                      Edit
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="outline-secondary"
                        onClick={handleCancelEdit}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" variant="primary">
                        Update
                      </Button>
                    </>
                  )}
                </>
              )}
            </>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Expenses1;
